export const DOCUMENT_UPLOADER = {
    CLIENT: 10,
    ACCOUNTANT: 20,
};
export const DOCUMENT_DELETE_BLOCKED_REASON = {
    UPLOADED_BY_ACCOUNTANT: 'uploaded_by_accountant',
    ALREADY_PROCESSED: 'already_processed',
};
